import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser";

const IconTextSection = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    const { imageURL, title, textArray, v2 } = props

    if (isMobile)
        return (
    
            <section className="flex w100 white-bkg">
                <section className="flex col jcenter pad-30 main-middle-section-2">
                    <img loading="lazy" alt="Imagen" src={imageURL} className="main-middle-image-right"></img>
                    <h2 className="middle-section-title">{title}</h2>
                    {
                        (textArray?.map((t,index) => {
                            return (<article key={index}>{parse(t)}</article>)
                        }))
                    }
                </section>
            </section>
        )
    else
        return (
            <section className={(v2) ? "services-middle-section" : "publications-middle-section"}>
                <section className="main-middle-subsection ">
                    <h2 className="middle-section-title">{title}</h2>
                    {
                        (textArray?.map((t,index) => {
                            return (<article key={index}>{parse(t)}</article>)
                        }))
                    }
                </section>
                <img loading="lazy" alt="Imagen" src={imageURL} className={(v2) ? "services-image-right" : "main-middle-image-right"}></img>
            </section>
        )


}

export default IconTextSection